<template>
    <div class="thumbnail__watchlist-items">
        <span v-if="index !== null" class="thumbnail__watchlist-counter">{{ index + 1 }}</span>
        <TotemCheckbox v-model="entity.toDelete" :id="entity.id" :val="entity.id" v-if="editable" />
    </div>
</template>

<script>
export default {
    name: 'thumbnail-watchlist-items',
    props: {
        entity: Object,
        index: {
            type: Number,
            default: null
        },
        editable: Boolean
    }
}
</script>

<style lang="scss" scoped>
.thumbnail {
    &__watchlist-items {
        position: absolute;
        top: 8px;
        left: 8px;
        right: 2px;
        display: flex;
        justify-content: space-between;
    }

    &__watchlist-counter {
        background: $black;
        color: $white;
        font-size: 1.6rem;
        border-radius: 100%;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        font-family: 'Quicksand-Bold', sans-serif;
    }
}
</style>
